import React from 'react';
import {capitalize} from '../helpers'

class Errors extends React.Component {
  render () {
    const { errors } = this.props
    const ignore = this.props.ignore || []

    let localErrors

    if ( errors === undefined || errors.length === 0 ) {
      return ''
    } else if ( !(errors instanceof Array) && (typeof errors === 'object') ) {
      localErrors = Object.keys(errors).filter(error => ignore.indexOf(error) < 0).map(error=>{
        return capitalize(error) + " " + errors[error]
      })
    } else if ( errors instanceof Array ) {
      localErrors = errors.map( e => {
        return typeof e === 'object' ? e["error"] : e
      })
    }

    if ( localErrors.lenght === 0 ) {
      return ''
    }

    return (
      <div className="errors">
        <ul className="ls-025">
          {
            localErrors.map( (error, index) => {
              return (
                <li key={index}>{error.replace('Uid', 'email').replace(/^Base /, '')}</li>
              )
            })
          }
        </ul>
      </div>
    )
  }
}

export default Errors



// WEBPACK FOOTER //
// ./src/js/components/Errors.js